import { Avatar as A } from "radix-ui";
import { surface } from "./foundation";
export const Avatar = surface(A.Root, "avatar", "cyra-avatar");
export const AvatarImage = surface(A.Image, "avatar-image", "size-full object-cover");
export const AvatarFallback = surface(
  A.Fallback,
  "avatar-fallback",
  "flex size-full items-center justify-center",
);
